import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ResponsiveChord, generateChordData } from '@netsapiens/netsapiens-charts-library';
import { selectLayout } from '../../../state';

function LoaderChord() {
  const layout = useSelector(selectLayout);

  const [chordData, setChordData] = useState(generateChordData({ size: 1 }));
  const [matrixSize, setMatrixSize] = useState(1);

  const diceRoll = () => {
    const size = matrixSize < 20 ? matrixSize + 1 : 3;
    setMatrixSize(size);
    setChordData(generateChordData({ size }));
  };

  useEffect(() => {
    const interval = setInterval(diceRoll, 1000);

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, []);

  const colorCount = (matrixSize / 2) + 1;
  const colors = [
    '#333',
    '#666',
    '#999',
    layout.brandPrimaryColor,
    '#ccc',
    layout.brandSecondaryColor,
    '#828282',
    layout.brandPrimaryColor,
  ];

  return (
    <ResponsiveChord
      {...chordData}
      matrixSize={matrixSize}
      colors={colors.slice(0, colorCount)}
      padAngle={0.04}
      innerRadiusRatio={0.94}
      enableLabel={false}
      isInteractive={false}
      animate
      motionStiffness={150}
      motionDamping={30}
      arcBorderWidth={0}
      ribbonBorderWidth={0}
    />
  );
}

export default LoaderChord;
